<template>
  <div class="d-flex align-items-center justify-content-between mb-3">
    <h1 class="mb-0">{{ title }}</h1>

    <div class="d-flex align-items-center header-actions">
      <b-button
          v-if="showButton"
          :variant="buttonVariant"
          :class="['header-btn', buttonClass]"
          @click="$emit('button-click')"
          :disabled="buttonDisabled"
      >
        {{ buttonText }}
      </b-button>

      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
import { BButton } from "bootstrap-vue";

export default {
  name: "PageHeader",
  components: { BButton },
  props: {
    title: {
      type: String,
      default: "لیست"
    },
    showButton: {
      type: Boolean,
      default: true
    },
    buttonText: {
      type: String,
      default: "افزودن"
    },
    buttonVariant: {
      type: String,
      default: "success"
    },
    buttonClass: {
      type: String,
      default: ""
    },
    buttonDisabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['button-click']
};
</script>